import { useTranslation } from 'react-i18next';
import { Chip } from '@/shared/ui/chips/Chip';
import type { FulfillmentStatus } from '@/shared/types/api/parcels';

type Props = {
  status: FulfillmentStatus;
  className?: string;
};

const STATUS_STYLES: Record<FulfillmentStatus, string> = {
  IN_PROGRESS: 'bg-amber-100 text-amber-800 border-amber-200',
  SORTING: 'bg-slate-100 text-slate-700 border-slate-200',
  COLLECTING: 'bg-sky-100 text-sky-800 border-sky-200',
  SHIPPING: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  ON_THE_WAY: 'bg-blue-100 text-blue-800 border-blue-200',
  ON_CUSTOMS: 'bg-amber-100 text-amber-800 border-amber-200',
  LOCAL_ON_THE_WAY: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  SHIPMENT_ON_CUSTOMERS: 'bg-emerald-100 text-emerald-800 border-emerald-200',
};

export const FulfillmentChip = ({ status, className }: Props) => {
  const { t } = useTranslation();
  return (
    <Chip tone={STATUS_STYLES[status]} className={className}>
      {t(`fulfillmentStatus.${status}`)}
    </Chip>
  );
};
